import {
  SET_CURRENT_AREA,
} from 'actiontypes/map';

export default function setCurrentArea(area) {
  return { type: SET_CURRENT_AREA, currentArea: area, payload: { area } };
}